function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFBE54;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "Refresh0",
  d: "M55.5,0v15c22.1,0,40,17.9,40,40c0,8.2-2.5,15.8-6.7,22.1L77.9,66.2c1.7-3.4,2.6-7.2,2.6-11.2 c0-13.8-11.2-25-25-25v15L33,22.5L55.5,0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "Refresh0",
  d: "M55.5,110V95c-22.1,0-40-17.9-40-40c0-8.2,2.5-15.8,6.7-22.1l10.9,10.9c-1.7,3.4-2.6,7.2-2.6,11.2 c0,13.8,11.2,25,25,25V65L78,87.5L55.5,110"
});

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Refresh_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Refresh.f4133592.svg";
export { ForwardRef as ReactComponent };